module.exports = __webpack_public_path__ + "static/media/mileage_2_9.b7133c76.png";